import { useEffect, useRef } from 'react';

export const useMountDetection = () => {

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => mounted.current = false;
    }, []);

    return mounted;
}